const PUBLIC_URL = process.env.PUBLIC_URL;

const images = {
  empty: `${PUBLIC_URL}/img/empty.jpg`,
  eyePassword: `${PUBLIC_URL}/img/eye-password.png`,
  eyeText: `${PUBLIC_URL}/img/eye-text.png`,
};

export default images;
